import { render } from "./DashboardFileUpload.vue?vue&type=template&id=7c8e1cbc"
import script from "./DashboardFileUpload.vue?vue&type=script&lang=js"
export * from "./DashboardFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__